export const LOGGER = (...data) => {
  console.log(...data);
};
